/* eslint-disable react/prop-types */
import React from "react";
import { Menu, Layout } from "antd";
import { object, string } from "prop-types";
import { UserOutlined, PlusOutlined } from "@ant-design/icons";
import { useLeadCapture } from "./lead-capture";

const { Header } = Layout;

const propTypes = {
  auth: object,
  selected: string,
};

const TopNav = ({ auth_user, selected, dashboard }) => {
  const openLeadCapture = useLeadCapture();
  return (
    <Header
      className={dashboard ? "header vc-app-header" : "header"}
      style={{
        display: "flex",
        height: "auto",
        padding: "10px 20px 10px 10px",
        background: dashboard ? undefined : "transparent",
        position: "relative",
      }}
    >
      <Menu
        mode="horizontal"
        defaultSelectedKeys={[selected]}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          background: "transparent",
          border: "transparent",
        }}
      >
        <Menu.Item
          className="nav-tab"
          key="link"
          onClick={() => openLeadCapture()}
          style={{
            lineHeight:
              dashboard || (auth_user.user && auth_user.user.uid) ? 2 : 4,
            color: dashboard
              ? undefined
              : auth_user.user && auth_user.user.uid
              ? "initial"
              : "white",
          }}
        >
          <span
            role="button"
            title="Request invite-only distribution access — join the queue"
          >
            <PlusOutlined /> Request Access
          </span>
        </Menu.Item>
        {auth_user.user && auth_user.user.uid ? (
          <Menu.Item
            className="nav-tab"
            key="logout"
            onClick={() => auth_user.signOut && auth_user.signOut()}
            style={{ lineHeight: 2 }}
          >
            <UserOutlined /> Logout
          </Menu.Item>
        ) : (
          <>
            <Menu.Item
              className="nav-tab"
              key="logout"
              onClick={() => {
                const element = document.getElementById("login");
                console.log(element);
                element.scrollIntoView({ behavior: "smooth" });
              }}
              style={{
                lineHeight: dashboard ? 2 : 4,
                color: dashboard ? undefined : "white",
              }}
            >
              <UserOutlined /> Login
            </Menu.Item>
          </>
        )}
      </Menu>
    </Header>
  );
};

TopNav.propTypes = propTypes;
export default TopNav;
